import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import ReceiptIcon from '@mui/icons-material/Receipt';
import StarIcon from '@mui/icons-material/Star';
import { Button, Container } from '@mui/material';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useMemo, useState } from 'react';
import Footer from 'src/components/Footer';
import { LazyTabPanel } from 'src/components/LazyTabPanel';
import PageHeader from 'src/components/PageHeader';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import MasterWorkoutExercises from 'src/pages/MasterWorkoutExercises/List';
import ApiService from 'src/services/apiService';
import { MasterWorkoutTabs } from 'src/types/MasterWorkout';
import MasterWorkoutViewModel from 'src/viewmodels/MasterWorkoutViewModel';
import CreateEditMasterWorkout from '../CreateOrEdit';
import MasterWorkoutMaxList from '../MasterWorkoutMaxList';

export const MasterWorkoutMainTabs: React.FC = observer(() => {
	const [currentTab, setCurrentTab] = useState(MasterWorkoutTabs.details)

	const masterWorkoutViewModel = useMemo(() => new MasterWorkoutViewModel(ApiService.instance), [])

	const { exportJson, clearCache } = masterWorkoutViewModel.masterWorkoutExerciseListViewModel

	const title = masterWorkoutViewModel.masterWorkout.name ? `${masterWorkoutViewModel.masterWorkout.name}` : 'Create Master Workout'
	const disableExercisesTab = _.isNil(masterWorkoutViewModel.masterWorkout.id)
	const showMasterWorkoutMaxTab = masterWorkoutViewModel.masterWorkout.enableMains
	return (
		<>
			<PageTitleWrapper maxWidth="xl">
				<PageHeader title={title}>
					<Box component={'span'}>
						<Button sx={{ mt: { xs: 2, md: 0 }, mx: 1 }} variant="outlined" onClick={clearCache}>
							Clear Cache
						</Button>
						<Button sx={{ mt: { xs: 2, md: 0 } }} variant="contained" color="secondary" onClick={exportJson}>
							Export
						</Button>
					</Box>
				</PageHeader>
			</PageTitleWrapper>
			<Container maxWidth="xl">
				<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
					<Tabs value={currentTab} onChange={(_, value) => setCurrentTab(value)}>
						<Tab value={0} label="Details" icon={<ReceiptIcon />} iconPosition="start" />
						<Tab value={1} label="Exercises" disabled={disableExercisesTab} icon={<StarIcon />} iconPosition="start" />
						{showMasterWorkoutMaxTab && <Tab value={2} label="Main Lifts" icon={<FitnessCenterIcon />} iconPosition="start" />}
					</Tabs>
				</Box>
				<LazyTabPanel value={currentTab} index={0}>
					<CreateEditMasterWorkout viewModel={masterWorkoutViewModel} />
				</LazyTabPanel>
				<LazyTabPanel value={currentTab} index={1}>
					<MasterWorkoutExercises viewModel={masterWorkoutViewModel.masterWorkoutExerciseListViewModel} />
				</LazyTabPanel>
				<LazyTabPanel value={currentTab} index={2}>
					<MasterWorkoutMaxList viewModel={masterWorkoutViewModel} />
				</LazyTabPanel>
			</Container>
			<Footer />
		</>
	)
})
